module.exports = __webpack_public_path__ + "static/media/screen-en.3d9ee517.png";